<template>
  <div class="row card borderless-card" style="box-shadow: none">
    <div class="col-12 layoutPadding-30" style="/*padding:0*/">
      <div
        class="row mb-3"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title mt-2 d-flex">
          <i class="material-icons-outlined user-font mr-2 material-icon-font"
            >assignment_turned_in</i
          >
          <div style="margin-top: auto; margin-bottom: auto">To-do</div>
        </div>
        <div class="mt-2">
          <button
            class="newTask"
            @click="handleCreateTodo"
            v-if="checkRole != 'Guest'"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
            New task
          </button>
        </div>
      </div>
      <b-tabs>
        <b-tab title="Upcoming Tasks" active>
          <upcoming-tasks :data="todos"></upcoming-tasks>
        </b-tab>
        <b-tab title="Completed Tasks">
          <completed-tasks :data="todos"></completed-tasks>
        </b-tab>
      </b-tabs>
      <!-- <tabulator-card
        id="theMainTableBoxTransactionDetails"
        :tableData="todoData.data"
        :tableOptions="todoData.options"
        :tableColumns="todoData.columns"
        @tabulatorDetails="getTabulatorDetails"
      >
        <template slot="header">
          <div class="row mb-3" style="justify-content: space-between; margin:auto">
            <div class="team-title mt-2">
              <i class="fas fa-icon fa-clipboard-check user-font mr-2"></i>To-Do
            </div>
            <div class>
              <button class="addUserBtn btn-wd" @click="handleCreateTodo">
                <i class="fa fa-plus" aria-hidden="true"></i>
                New task
              </button>
            </div>
          </div>
        </template>
      </tabulator-card>-->
      <dialogtodo v-model="dialogTodoData" v-if="showDialogModal"></dialogtodo>
    </div>
  </div>
</template>
<script>
import { TabulatorCard } from "../../../components/index";
import { mapGetters } from "vuex";
import moment from "moment";
import DialogAddTodo from "../Dialogs/DialogAddTodo";
import api from "../../../axios_api";
import UpcomingTasks from "./UpcomingTask";
import CompletedTasks from "./CompletedTask";

export default {
  components: {
    TabulatorCard,
    [DialogAddTodo.name]: DialogAddTodo,
    [UpcomingTasks.name]: UpcomingTasks,
    [CompletedTasks.name]: CompletedTasks,
  },
  data() {
    return {
      showDialogModal: false,
      dialogTodoData: {},
    };
  },
  created() {
    // this.$store.getters["todo/componentTodos"](
    //   "dashboard",
    //   this.$route.params.workspace_id
    // );
    this.$store.getters["todo/componentTodos"](
      "todo",
      this.$route.params.workspace_id
    );
  },
  computed: {
    ...mapGetters("todo", ["todos", "workspaceTodos"]),
    ...mapGetters("team", ["getAllUsers"]),
    ...mapGetters("todo", ["current_component"]),
    ...mapGetters("role", ["checkRole"]),
    // todoData() {
    //   let todos = JSON.parse(JSON.stringify(this.todos));
    //   var teams = this.getAllUsers;
    //   for (var i = 0; i < todos.length; i++) {
    //     todos[i].index = i;
    //     todos[i].modified = moment(todos[i].modified).format("MM/DD/YYYY");
    //     todos[i].due_date = moment(todos[i].due_date).format("MM/DD/YYYY");
    //     todos[i].assignedName = teams.find(item => {
    //       return item.account._id == todos[i].assigned_to;
    //     });
    //   }
    //   return {
    //     data: todos,
    //     options: {
    //       layout: "fitColumns",
    //       tooltips: true,
    //       pagination: "local",
    //       paginationSize: 20,
    //       paginationSizeSelector: true,
    //       tooltipsHeader: true
    //     },
    //     columns: this.tableColumns
    //   };
    // },
    // tableColumns() {
    //   const self = this;
    //   return [
    //     {
    //       title: "Priority",
    //       field: "priority",
    //       sorter: "string",
    //       resizable: true,
    //       cellClick: function(e, cell) {
    //         self.handleEditTodo(cell._cell.row.data, cell._cell.row.data.index);
    //       }
    //     },
    //     {
    //       title: "Title",
    //       field: "title",
    //       sorter: "string",
    //       resizable: true,
    //       cellClick: function(e, cell) {
    //         self.handleEditTodo(cell._cell.row.data, cell._cell.row.data.index);
    //       }
    //     },
    //     {
    //       title: "Assigned To",
    //       field: "name",
    //       sorter: "string",
    //       resizable: true,
    //       cellClick: function(e, cell) {
    //         self.handleEditTodo(cell._cell.row.data, cell._cell.row.data.index);
    //       },
    //       formatter: function(cell, formatterParams) {
    //         let data = cell.getData();
    //         let name = "";
    //         if (data.assignedName && data.assignedName.account) {
    //           if (
    //             data.assignedName.account.firstName !=
    //             data.assignedName.account.lastName
    //           )
    //             name = `${data.assignedName.account.firstName} ${data.assignedName.account.lastName}`;
    //           else name = data.assignedName.account.firstName;
    //         }
    //         return name;
    //       }
    //     },
    //     {
    //       title: "Due Date",
    //       field: "due_date",
    //       sorter: "string",
    //       cellClick: function(e, cell) {
    //         self.handleEditTodo(cell._cell.row.data, cell._cell.row.data.index);
    //       }
    //     },
    //     {
    //       title: "Action Type",
    //       field: "action_type",
    //       sorter: "string",
    //       cellClick: function(e, cell) {
    //         self.handleEditTodo(cell._cell.row.data, cell._cell.row.data.index);
    //       },
    //       resizable: true
    //     },
    //     {
    //       title: "",
    //       field: "",
    //       sorter: "string",
    //       headerSort: false,
    //       resizable: true,
    //       cellClick: function(e, cell) {
    //         self.handleStatusEditTodo(
    //           cell._cell.row.data,
    //           cell._cell.row.data.index
    //         );
    //       },
    //       formatter: function(cell, formatterParams) {
    //         let data = cell.getData();
    //         return `<i class="far fa-check-circle"></i>`;
    //       }
    //     }
    //   ];
    // }
  },
  mounted() {
    this.$store.commit("todo/setCurrentComponent", "todo");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | To-do`;
    this.$store
      .dispatch("todo/getTotalTodos", this.$route.params.workspace_id)
      .then((resp) => {
        this.$store
          .dispatch("todo/getCompleteTodos", this.$route.params.workspace_id)
          .then((response) => {
            this.checkNotificationId();
          });
      });
  },
  watch: {
    $route(to, from) {
      let data = this.$store.getters["todo/componentTodos"](
        "todo",
        this.$route.params.workspace_id
      );
      this.$store
        .dispatch("todo/getTotalTodos", this.$route.params.workspace_id)
        .then((resp) => {
          this.$store
            .dispatch("todo/getCompleteTodos", this.$route.params.workspace_id)
            .then((response) => {
              this.checkNotificationId();
            });
        });
    },
  },
  methods: {
    checkNotificationId() {
      let self = this;
      let id = this.$route.query.id;
      if (id && id.length > 0) {
        let todoData = this.workspaceTodos.find((item) => item._id == id);
        if (todoData && todoData._id) {
          let index = todoData.assigned_to.findIndex(
            (item) => item == self.$route.params.account_id
          );
          if (index >= 0) {
            window.sessionStorage.setItem(
              "todoAssignes",
              JSON.stringify(todoData.assigned_to)
            );
            window.sessionStorage.setItem("todoData", JSON.stringify(todoData));
            let getAllUsers = this.$store.getters["team/getAllUsers"];
            if (getAllUsers.length > 0) {
              this.showDialogModal = true;
              self.dialogTodoData = {
                isShow: true,
                isCreate: false,
                data: todoData,
                assigned_to: todoData.assigned_to,
              };
            } else {
              setTimeout(() => {
                self.showDialogModal = true;
                self.dialogTodoData = {
                  isShow: true,
                  isCreate: false,
                  data: todoData,
                  assigned_to: todoData.assigned_to,
                };
              }, 1000);
            }
          } else {
            self.$toaster.error("You have been removed from this Todo.");
          }
          this.$router.push(
            `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/todos`
          );
        } else {
          self.$toaster.error("This Todo has been deleted");
          self.$router.push(
            `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/todos`
          );
        }
      }
    },
    getTabulatorDetails(list) {
      this.tabulator = list;
    },
    handleCreateTodo() {
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: true,
        data: {
          priority: "medium",
          due_date: new Date().setDate(new Date().getDate() + 3),
          //assigned_to: this.$route.params.account_id,
          status: "New",
          is_quick_task: false,
        },
        assigned_to: [this.$route.params.account_id],
      };
    },
    handleEditTodo(item, index) {
      let todoData = JSON.parse(JSON.stringify(item));
      this.$store.commit("todo/setTodoIndex", {
        _id: todoData._id,
        index: index,
      });
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: false,
        data: todoData,
      };
    },
    handleStatusEditTodo(item, index) {
      this.$store.commit("todo/setTodoIndex", {
        _id: item._id,
        index: index,
      });
      api
        .patch(`todo/${item._id}`, {})
        .then((data) => {
          this.$store.commit("todo/EditTodoData", data.data.encrypt.data);
          this.$store.getters["todo/componentTodos"](
            this.current_component,
            this.$route.params.workspace_id
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.material-icon-font {
  font-size: 20px;
  margin-top: auto;
  margin-bottom: auto;
}
</style>